import { useEffect, useState} from 'react';
import axios from 'axios';

const useGetCanEmpleados = () => {
    const [canEmpleados, setCanEmpleados] = useState([]);

    useEffect(() => {
        const data = async () => {
            const response = await axios.get(process.env.REACT_APP_API_URL+'?getCanEmpleados=true');
            setCanEmpleados(response.data);
        }
        
        data()
            .catch(console.error);
    }, []); 
    return canEmpleados;
}

export default useGetCanEmpleados;